module.exports = __webpack_public_path__ + "media/country_flags/gq-d137c8e8.png";